// extracted by mini-css-extract-plugin
export default {"title":"ModalNanny_title__YXXry","list":"ModalNanny_list__sxHW9","buttonContainer":"ModalNanny_buttonContainer__Kpy7m","button":"ModalNanny_button__cq4sS"};